import React, { PureComponent } from 'react';
import { Avatar } from '@material-ui/core';
import './avatar.scss';

export class CommonAvatar extends PureComponent {
  generateColor = (str, s, l) => {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
  };

  getInitials = (name) => {
    return name
      .trim()
      .split(' ')
      .map((name) => name.substring(0, 1).toUpperCase())
      .slice(0, 1)
      .join('');
  };

  render() {
    const { name, style = {}, onClick = () => {}, className = '' } = this.props;
    const color = this.generateColor(name, 40, 40);
    const backgroundColor = this.generateColor(name, 35, 80);
    const initials = this.getInitials(name);

    return (
      <Avatar
        style={{
          color,
          backgroundColor,
          border: `1px solid ${color}`,
          width: `28px`,
          height: `28px`,
          fontSize: `.875em`,
          ...style,
        }}
        onClick={onClick}
        className={className}
      >
        {initials}
      </Avatar>
    );
  }
}
